import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    border: 1px solid ${theme.palette.neutral[200]};

    > header {
      display: flex;
      padding: ${theme.layout.spacing(2, 3)};
      align-items: center;
      gap: ${theme.layout.spacing(1)};
      justify-content: space-between;
      align-items: center;
      min-height: 80px;

      h3 {
        flex: 1;
        text-align: left;
        font-size: ${theme.typography.sizes.title3};
        color: ${theme.palette.text.main};
      }

      > div {
        display: flex;
        align-items: center;
        gap: 0.75rem;
      }
    }
  `}
`;
